import { initToggleContent } from './scripts/toggle-content'
import { initAddToCartSuccessModalFocus, initCalendarEvents } from './scripts/calendar.js'
import './scripts/celebreat-calendar'

initCalendarEvents()
initAddToCartSuccessModalFocus()
initToggleContent()
